// refundInitiationMutationSlice.js
import { apiSlice } from "../apiSlice";
import { defaultRefundInitiationFilters } from "./refundInitiationApiSlice";


export const refundInitiationMutationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    patchRefundInitiationStatus: builder.mutation({
      query: ({ id, status, remarks }) => ({
        url: `refund_payments/${id}`,
        method: "PATCH",
        body: {
          status,
          remarks,
        },
      }),

      async onQueryStarted(
        { id, status, remarks, filters },
        { dispatch, queryFulfilled }
      ) {
        try {
          const { data: updatedRefundInitiation } = await queryFulfilled;

          const safeFilters = filters ?? defaultRefundInitiationFilters;

          dispatch(
            apiSlice.util.updateQueryData(
              "getRefundInitiationList",
              safeFilters,
              (draft) => {
                const existing = draft.entities[id];
                if (existing) {
                  Object.assign(existing, updatedRefundInitiation);
                }
              }
            )
          );
        } catch (error) {
          console.error("Refund initiation update failed:", error);
        }
      },

      invalidatesTags: (result, error, { id }) => [
        { type: "refundInitiation", id },
      ],
    }),
  }),
});

export const {
  usePatchRefundInitiationStatusMutation,
} = refundInitiationMutationApiSlice;
